export const subtitles = {
    "1": {
        "startTime": 35.79,
        "endTime": 41.42,
        "transcript": "Kitak', yaa, au͡g'u qaneryullren.",
        "translation": "So, okay, what you wanted to say."
    },
    "2": {
        "startTime": 41.43,
        "endTime": 46.48,
        "transcript": "Ii-i, qaneryullemnek waniw' qanqatartua makunek.",
        "translation": "Okay, I'm going to speak about these things I want to say."
    },
    "3": {
        "startTime": 47.21,
        "endTime": 54.62,
        "transcript": "Waten tan'gaurluullemni tan'gaurluullemteńi makunek",
        "translation": "These things when I was a boy like this, when we were boys"
    },
    "4": {
        "startTime": 56.77,
        "endTime": 64.98,
        "transcript": "Makunek-wa tua-i nunam qainganelngurnek neqemteńek pitarkanek",
        "translation": "These things on the land that we eat and hunt"
    },
    "5": {
        "startTime": 65.27,
        "endTime": 70.48,
        "transcript": "Imarpigmiutaat, makut-llu cali yaqulget.",
        "translation": "Marine animals, and these birds."
    },
    "6": {
        "startTime": 71.13,
        "endTime": 77.31,
        "transcript": "Maa-i mat'um nalliini nang'ut.",
        "translation": "These days, there are no more."
    },
    "7": {
        "startTime": 79.015,
        "endTime": 85.615,
        "transcript": "Makut waten imarpigmiutaat enurnaringut.",
        "translation": "These marine animals are getting scarce like this."
    },
    "8": {
        "startTime": 85.69,
        "endTime": 91.9,
        "transcript": "Makut-llu yaqulget cali enurnaringluteng.",
        "translation": "These birds are also getting scarce."
    },
    "9": {
        "startTime": 92.15,
        "endTime": 97.76,
        "transcript": "Imumi waten tan'gaurluullemteńi, tan'gaurluullemni-w' tua-i",
        "translation": "Back when we were boys like this, when I was a boy"
    },
    "10": {
        "startTime": 97.76,
        "endTime": 105.31,
        "transcript": "Up'nerkami amllepiatullruut yaqulget.",
        "translation": "There used to a great many birds in the spring."
    },
    "11": {
        "startTime": 105.87,
        "endTime": 109.74,
        "transcript": "Yuilquq nepaitellruuq.",
        "translation": "The wilderness was quiet."
    },
    "12": {
        "startTime": 110.16,
        "endTime": 113.14,
        "transcript": "Waten ayuqellrunrituq.",
        "translation": "It wasn't like this."
    },
    "13": {
        "startTime": 113.145,
        "endTime": 121.615,
        "transcript": "Tem'ingelriamek waten niicuunata ertaqan, ellami tem'irtellrianek.",
        "translation": "We wouldn't hear things rumbling at dawn, things rumbling outside."
    },
    "14": {
        "startTime": 121.905,
        "endTime": 130.525,
        "transcript": "Up'nerkami waten up'nerkiaqameng pavani Akulmi nunanirpak.",
        "translation": "When they went to spring camp in the spring inland in the Akula region, it was wonderful."
    },
    "15": {
        "startTime": 131.07,
        "endTime": 135.35,
        "transcript": "Yaqulget ayuqenrilnguut qalrialuteng.",
        "translation": "Different birds would be calling."
    },
    "16": {
        "startTime": 139.215,
        "endTime": 147.765,
        "transcript": "Makut-llu pissulriit waten atakumi atakuara'rqan, atakuaratullruut kanaqlagcualriit",
        "translation": "And these hunters in the evening like this, early in the evening, they would spend the evening trapping muskrats"
    },
    "17": {
        "startTime": 147.885,
        "endTime": 150.585,
        "transcript": "Up'nerkillerni pavani.",
        "translation": "In the spring camps inland."
    },
    "18": {
        "startTime": 151.05,
        "endTime": 158.38,
        "transcript": "Tua-i cingqullagangnaurtut nut'galriarurrluni waten tua-i piciatun.",
        "translation": "They would make loud popping noises, the air filled with gunshots like this, for various things."
    },
    "19": {
        "startTime": 158.62,
        "endTime": 168.51,
        "transcript": "Makut-wa yaqulget pavani nanvat ceńaitni-ll' up'nerkitullruameng.",
        "translation": "There were these birds since they set up spring camps inland on lake shores."
    },
    "20": {
        "startTime": 168.91,
        "endTime": 174.13,
        "transcript": "Anglanaqluteng yaqulget kuimalriit qalrialuteng.",
        "translation": "The swimming birds that were calling were fun."
    },
    "21": {
        "startTime": 177.695,
        "endTime": 182.375,
        "transcript": "Nunaniqluni tua-i piaqluni up'nerkami.",
        "translation": "It would be wonderful in the spring."
    },
    "22": {
        "startTime": 183.75,
        "endTime": 193.75,
        "transcript": "Qaillun wii umyuarteqaqama, pissurnanriiceteng-qaa nang'ut?",
        "translation": "How, when I think about it, are they gone because they aren't hunting them anymore?"
    },
    "23": {
        "startTime": 196.805,
        "endTime": 203.48,
        "transcript": "Wangkuta-llu tan'gaurlucuarni cali waten elitnauruterluta:",
        "translation": "And we little boys also had this lesson:"
    },
    "24": {
        "startTime": 203.48,
        "endTime": 210.04,
        "transcript": "Pissungqerrluta makunek yaquleyagarnek.",
        "translation": "We hunted these little birds."
    },
    "25": {
        "startTime": 210.635,
        "endTime": 213.055,
        "transcript": "Amllepiarluteng cali.",
        "translation": "There were also a lot of them."
    },
    "26": {
        "startTime": 213.11,
        "endTime": 220.22,
        "transcript": "Pitgaquurluki tamakunek yaquleyagarnek pissurnaurtukut.",
        "translation": "We would hunt those little birds by shooting arrows at them."
    },
    "27": {
        "startTime": 220.98,
        "endTime": 228.14,
        "transcript": "Tamakut-llu pitaput iciw' egcuunaki.",
        "translation": "And, you know, we wouldn't discard those things we caught."
    },
    "28": {
        "startTime": 228.235,
        "endTime": 238.335,
        "transcript": "Makut cali nasaurlullraat meqtayagarluki kenirnaurait.",
        "translation": "Also, these little girls would pluck their feathers and cook them."
    },
    "29": {
        "startTime": 238.72,
        "endTime": 247.35,
        "transcript": "Tau͡gken cali aanamta imum keniraqluki cali pitaput, egcuunaki.",
        "translation": "However, our mother would also cook what we caught, not discard them."
    },
    "30": {
        "startTime": 247.71,
        "endTime": 257.25,
        "transcript": "Waten qigcikluki makut nunamiutaat, neqput kencikluki au͡gkut pitullruit.",
        "translation": "People back then would respect these land animals, and revered our food."
    },
    "31": {
        "startTime": 259.875,
        "endTime": 263.73,
        "transcript": "Mat'um tau͡gken tua-i nalliini qaillun piat?",
        "translation": "But what's become of them these days?"
    },
    "32": {
        "startTime": 263.73,
        "endTime": 274.54,
        "transcript": "Makut-llu yup'ut pissuyuirulluki imkut makut yaquleyagaat pitgaquurluki pitulput.",
        "translation": "And our children have stopped hunting these little birds that we used to shoot arrows at."
    },
    "33": {
        "startTime": 274.73,
        "endTime": 284.96,
        "transcript": "Tayima tua-i tangrrunanrirluteng maani nunam qaingani up'nerkami pissulalput.",
        "translation": "The thigns that we used to hunt in the spring are no longer seen here on the land."
    },
    "34": {
        "startTime": 285.52,
        "endTime": 292.83,
        "transcript": "Tuamtellu cali kiagmi tukraqameng napamiutaat",
        "translation": "Then in the summer, when the birds in the trees hatched"
    },
    "35": {
        "startTime": 293.08,
        "endTime": 298.8,
        "transcript": "Amllepiarluteng puyurcivignun it'raluteng.",
        "translation": "There would be a great many of them going into smoke houses."
    },
    "36": {
        "startTime": 299.055,
        "endTime": 303.455,
        "transcript": "Wangkuta-wa cali maani pitgaquurqeput.",
        "translation": "We would also shoot arrows at them here."
    },
    "37": {
        "startTime": 306.35,
        "endTime": 312.61,
        "transcript": "Amiiyaarluki, uuggun qat'gaitgun cilla'arrluki kemgit au͡g'arluki.",
        "translation": "We skinned the little things, opened them up here on their chests and removed their flesh."
    },
    "38": {
        "startTime": 312.615,
        "endTime": 318.165,
        "transcript": "Uuggun-llu yaqu͡rita piitgun ayagciqerluki.",
        "translation": "And we would put props here on their wings."
    },
    "39": {
        "startTime": 318.355,
        "endTime": 322.895,
        "transcript": "Nuucirluki-ll' nutaan napamek agarqurluki.",
        "translation": "Then we would [?thread] them through a tree and hang them."
    },
    "40": {
        "startTime": 323.75,
        "endTime": 331.12,
        "transcript": "Wagg'uq-qaa nakaculiluki. Tuaten pitullruut.",
        "translation": "They called that \"making them into bladders.\" That's what they did."
    },
    "41": {
        "startTime": 331.71,
        "endTime": 337.04,
        "transcript": "Amllepiarluteng yaquleyagaat cakaniyuunateng.",
        "translation": "There would be a great many little birds with no change [in population]."
    },
    "42": {
        "startTime": 337.96,
        "endTime": 342.62,
        "transcript": "Makut-wa cali aulukesteput",
        "translation": "Then our caretakers here"
    },
    "43": {
        "startTime": 342.899,
        "endTime": 356.499,
        "transcript": "Up'nerkamek tua-i ayagluteng yaqulget waten cetunatkameggnun ner'aqluki. Tua-i neqekluki, kayanguit-llu.",
        "translation": "Starting from the spring, they would eat birds until they went downriver like this. It was their food, along with their eggs."
    },
    "44": {
        "startTime": 356.506,
        "endTime": 362.106,
        "transcript": "Camek niicuunata nangqatalrianek, ikeggliinalrianek.",
        "translation": "We wouldn't hear about them going away or depleting."
    },
    "45": {
        "startTime": 362.113,
        "endTime": 365.6,
        "transcript": "Tau͡gaam waten pitullruut:",
        "translation": "But this is what they did:"
    },
    "46": {
        "startTime": 365.6,
        "endTime": 374.0,
        "transcript": "Allamiaquaqan cat ukut ikgetaqluteng, caaqameng-ll' amllerrluteng.",
        "translation": "Every year, there would be less of these things, and there would occassionally be a lot of them."
    },
    "47": {
        "startTime": 374.007,
        "endTime": 380.369,
        "transcript": "Waten ikgeliqetaarluteng, tau͡gaam nangyuunateng, cakaniyuunateng.",
        "translation": "There would occassionally be less, but they wouldn't be gone, wouldn't go away."
    },
    "48": {
        "startTime": 380.382,
        "endTime": 386.932,
        "transcript": "Amllerllainarluteng yaqulget imarpigmiutaat-llu.",
        "translation": "There was always a lot of birds and marine animals."
    },
    "49": {
        "startTime": 387.601,
        "endTime": 397.164,
        "transcript": "Tua-i-llu tamakut waten yaqulget up'nerkami nerluki yaavet tua-i neq'ngellerkaanun.",
        "translation": "Then they would eat those birds like this in the spring up until there were fish."
    },
    "50": {
        "startTime": 397.176,
        "endTime": 401.751,
        "transcript": "Cetuameng tau͡gaam taqluki, ayanqigtevkenateng.",
        "translation": "They only stopped when they went downriver, didn't go out hunting again."
    },
    "51": {
        "startTime": 401.932,
        "endTime": 411.807,
        "transcript": "Nuna tua-i yugtairulluku waten Akula, imarpigmi, unani tau͡gaam Kusquqvagmi.",
        "translation": "There would be no one left in the Akula region like this, but only down in the ocean, on the Kuskokwim."
    },
    "52": {
        "startTime": 412.288,
        "endTime": 418.963,
        "transcript": "Neqnun cali cauluteng. Amllepiarluteng call' neqet.",
        "translation": "They would turn to fish. There were also a great many fish."
    },
    "53": {
        "startTime": 422.594,
        "endTime": 435.794,
        "transcript": "Tamaaggun-wa kencikellratgun Agayutem cikiutekngamiki kencikellratgun tua-i amllerrlainartelluki.",
        "translation": "Through their reverence, since they are Gods gifts, they were always in plenty through their reverence."
    },
    "54": {
        "startTime": 436.926,
        "endTime": 447.913,
        "transcript": "Maa-i mat'um nalliini umyuangcarqama tamakut neqrateng tua-i makut neqteng murilkelluki, mulngakluki.",
        "translation": "When I ponder upon it these days, they watched over and were careful about what food they had, their food."
    },
    "55": {
        "startTime": 448.751,
        "endTime": 453.651,
        "transcript": "Neq'lipiatullruuq agaani waten tan'gaurlullraullemteńi.",
        "translation": "There used to be a lot of fish across there when we were boys like this."
    },
    "56": {
        "startTime": 455.208,
        "endTime": 458.67,
        "transcript": "Puukaquaqluteng-llu maavet ceńamun.",
        "translation": "They would also collide here on the bank."
    },
    "57": {
        "startTime": 458.683,
        "endTime": 467.683,
        "transcript": "Kuimarqamta-llu iliini maaggun naw'un puukaraqluta neqet.",
        "translation": "And when we swan, sometimes the fish would ram into us somewhere here."
    },
    "58": {
        "startTime": 469.002,
        "endTime": 478.665,
        "transcript": "Tua-i-llu mat'um nalliini tua-i-w' kencikenriamceteng cat nangengluteng.",
        "translation": "Then these days, since we do not rever them anymore, things are depleting."
    },
    "59": {
        "startTime": 479.477,
        "endTime": 482.327,
        "transcript": "Kencikellruit au͡gkut.",
        "translation": "People back then revered them."
    },
    "60": {
        "startTime": 485.846,
        "endTime": 494.796,
        "transcript": "Tuamtellu waten wangkutnun tua-i yugnun atalliniut makut neqput.",
        "translation": "Then, our food are evidently connected to us people."
    },
    "61": {
        "startTime": 494.803,
        "endTime": 505.265,
        "transcript": "Tuamtellu cetuanek makut piaqata inerqurnauraitkut ivraasqevkenata, tayim' cetuarcurqata.",
        "translation": "Then when they would hunt belugas, they would admonish us against ever wading, when they hunted belugas."
    },
    "62": {
        "startTime": 505.366,
        "endTime": 513.316,
        "transcript": "Maavet ukalirnermun agaantaqamta ivraqaasqevkenata inerquanauraitkut.",
        "translation": "On this side, when we were across there, they would admonish us against ever wading."
    },
    "63": {
        "startTime": 513.46,
        "endTime": 520.86,
        "transcript": "Cetuarcurniluku tamakut qaill' pilriit tuaten inerqutullruitkut.",
        "translation": "They said that those people were hunting belugas and admonished us like that."
    },
    "64": {
        "startTime": 521.829,
        "endTime": 529.667,
        "transcript": "Tua-i-llu mat'um nalliini tayim' nangluteng pissuyuirucamceteng.",
        "translation": "And there are no more these days because we don't hunt them."
    },
    "65": {
        "startTime": 529.855,
        "endTime": 540.942,
        "transcript": "Makut-ll' imkut yaquleyagaat nangluteng tayima pissurnanriimceteng wangkuta pitgaquurluki.",
        "translation": "And there are no more of these little birds because we don't hunt them with arrows anymore."
    },
    "66": {
        "startTime": 542.33,
        "endTime": 557.542,
        "transcript": "Tau͡gken makut aipaimta kellutestaita amllericangnaqsaaqluki inerquuteksagulluki pissuyuirutevkarluki yaqulget.",
        "translation": "However, these [Caucasian] counterparts of ours who regulate them, make restrictions to try to elevate their populations, and have us stop hunting birds."
    },
    "67": {
        "startTime": 558.98,
        "endTime": 565.08,
        "transcript": "Makut yaqulget arulairucuitellruit au͡gkut anglicartemta.",
        "translation": "Our caretakers back then would stop [hunting] birds."
    },
    "68": {
        "startTime": 565.099,
        "endTime": 570.349,
        "transcript": "Tua-i waten pavani up'nerkami neqkerraarluki",
        "translation": "After that was their food source in the spring like this"
    },
    "69": {
        "startTime": 570.356,
        "endTime": 581.418,
        "transcript": "Tua-i-ll' cali cetuameng neqnek pirraarluteng imkut tengesciigaliata ingcata",
        "translation": "Then when they went downriver, after [eating] fish, when they were unable to fly as they molted"
    },
    "70": {
        "startTime": 581.431,
        "endTime": 587.656,
        "transcript": "Piyagaat-llu irniarit angtateksaguarcata",
        "translation": "When their chicks, their offspring, became the same size"
    },
    "71": {
        "startTime": 587.675,
        "endTime": 590.412,
        "transcript": "Nutaan cali tamakut pissungluki.",
        "translation": "They would start hunting those too."
    },
    "72": {
        "startTime": 590.425,
        "endTime": 594.425,
        "transcript": "Qayateng imirluki tekirqengnaurtut.",
        "translation": "They would fill their kayaks and arrive en masse."
    },
    "73": {
        "startTime": 596.944,
        "endTime": 601.382,
        "transcript": "Cakaniyuunateng-llu, ikegliyuunateng.",
        "translation": "And they wouldn't be affected, wouldn't decrease."
    },
    "74": {
        "startTime": 602.395,
        "endTime": 608.407,
        "transcript": "Mat'um tau͡gken tua-i naliini cat tamangluteng, yaquleyagaat-llu.",
        "translation": "Yet these days, things are disappearing, including little birds."
    },
    "75": {
        "startTime": 608.57,
        "endTime": 613.458,
        "transcript": "Wall'u-qaa tua-i pissurnanriimceteng piut?",
        "translation": "Or is it because we've stopped hunting them?"
    },
    "76": {
        "startTime": 615.208,
        "endTime": 619.583,
        "transcript": "Tua-i au͡gna waten qanengssaka pitauq.",
        "translation": "That's the extent of what I have to say."
    },
    "77": {
        "startTime": 619.589,
        "endTime": 629.864,
        "transcript": "Kitak' im'umek, iciw' ayagalriani, tayim' iciw' ak'a ayagatullret?",
        "translation": "Then, you know, those who travel, you know, those who traveled a long time ago?"
    },
    "78": {
        "startTime": 629.883,
        "endTime": 638.983,
        "transcript": "Iciw' pellaalliaqa wall'u-q' qaill' piaqata kaingaqameng canek nertullruat yuilqumi?",
        "translation": "You know, if they happened to get lost or something happened, what would they eat in the wilderness if they got hungry?"
    },
    "79": {
        "startTime": 641.427,
        "endTime": 645.627,
        "transcript": "Kaingaqameng-qaa neqkaunateng?",
        "translation": "You mean when they get hungry without food?"
    },
    "80": {
        "startTime": 645.646,
        "endTime": 652.584,
        "transcript": "Yaa, iciw' yuilqumi pellaakata qaill' neqkailkata camek neryugngaat?",
        "translation": "Yes, you know, if they're lost in the wilderness without food, what can they eat?"
    },
    "81": {
        "startTime": 653.334,
        "endTime": 660.222,
        "transcript": "Qaill' iciw' uksumi wall'u-q' kiagmi wall'u-q' up'nerkami wall'u-q' uksuarmi?",
        "translation": "How would they do it, you know, in the winter or summer or spring or fall?"
    },
    "82": {
        "startTime": 660.835,
        "endTime": 662.272,
        "transcript": "Yaa.",
        "translation": "Well."
    },
    "83": {
        "startTime": 665.822,
        "endTime": 679.822,
        "transcript": "Au͡gkut-wa waten alerqutullruitkut tua-i neqkailkumta arenqiallugeskumta",
        "translation": "The people back then would instruct us like this if we are without food, if we come upon misfortune"
    },
    "84": {
        "startTime": 682.266,
        "endTime": 685.429,
        "transcript": "Neqkaunata pikumta",
        "translation": "If we are without food"
    },
    "85": {
        "startTime": 692.304,
        "endTime": 696.054,
        "transcript": "Neqengqerrsugngayaaquq waten:",
        "translation": "One can actually have food like this:"
    },
    "86": {
        "startTime": 697.211,
        "endTime": 707.048,
        "transcript": "Maa-i makut uugnaraat neqkaugut cailkuni yuilqumi, tau͡gaam kenengqerquni.",
        "translation": "These voles are a source of food if one has nothing in the wilderness, but only if they have a fire."
    },
    "87": {
        "startTime": 708.261,
        "endTime": 711.911,
        "transcript": "Tamakut tamaa-i neqkauyaaqut.",
        "translation": "Those are actually a source of food."
    },
    "88": {
        "startTime": 712.593,
        "endTime": 722.93,
        "transcript": "Tau͡gken cali niitetullrulua, makut-gguq qangqiiret anait imkut neqnguut.",
        "translation": "However, I also used to hear that ptarmigan feces are edible."
    },
    "89": {
        "startTime": 722.943,
        "endTime": 724.718,
        "transcript": "Tamaa-i tamakut.",
        "translation": "There they are."
    },
    "90": {
        "startTime": 724.812,
        "endTime": 734.499,
        "transcript": "Ava-i apeskevnga qaillun neqkailkuneng nerengnaqlerkait.",
        "translation": "You just asked me how they could try to feed themselves if they are without food."
    },
    "91": {
        "startTime": 735.324,
        "endTime": 743.574,
        "transcript": "Makut uugnaraat uksumi tangrruutuut.",
        "translation": "We see these voles in the winter."
    },
    "92": {
        "startTime": 745.593,
        "endTime": 750.856,
        "transcript": "Tamaa-i tamakut neqkauyaaqut.",
        "translation": "Those are actually food sources."
    },
    "93": {
        "startTime": 750.868,
        "endTime": 757.806,
        "transcript": "Tau͡gaam-am cali nerailkuni angu qassaasqevkenaku.",
        "translation": "But they also said that if he hasn't eaten in a while, never to eat raw meat."
    },
    "94": {
        "startTime": 759.019,
        "endTime": 771.044,
        "transcript": "Wall'u ayainanermini, akaurrluku-w' tua-i nereksaitellni waten taluyillruarmek tekiskuni",
        "translation": "Or as he travels and he hasn't eaten in a long time, if he comes upon a little fish trap like this"
    },
    "95": {
        "startTime": 771.05,
        "endTime": 776.163,
        "transcript": "Iciw' imkut can'giicuayagaat alungya'rnek pitullrat?",
        "translation": "You know those small blackfish that they call blackfish fry?"
    },
    "96": {
        "startTime": 776.3,
        "endTime": 787.6,
        "transcript": "Angu nerqaasqenritait tamakut elliinek, elliinek pitaqeciqniluku anrutaanun.",
        "translation": "They said to never eat those, saying that they will [kill] themselves through their stomachs."
    },
    "97": {
        "startTime": 790.394,
        "endTime": 798.207,
        "transcript": "Una neraicaraq, arcaqertuq tau͡gaam una meqsulleq kiimi.",
        "translation": "Going a long time without eating, though, the only important thing is being thirsty."
    },
    "98": {
        "startTime": 799.494,
        "endTime": 805.694,
        "transcript": "Arenqiallugeskuni ayakuni neqkailkuni meqsukuni",
        "translation": "If one comes upon misfortune in travels, without food, and is thirsty"
    },
    "99": {
        "startTime": 805.701,
        "endTime": 819.026,
        "transcript": "Inerquumaukut taqsuqluta qanikcarmek neresqevkenata meqsungramta.",
        "translation": "We are admonished against eating snow when we're tired even if we're thirsty."
    },
    "100": {
        "startTime": 820.607,
        "endTime": 833.707,
        "transcript": "Qanikcartuaraasqevkenata wangkutnek piciqniluta. Ircaqurput pinialiciqniluku tuaten qanikcarmek nerkumta.",
        "translation": "They told us not to eat snow, saying that we would [kill] ourselves. They said our heart would weaken if we eat snow like that."
    },
    "101": {
        "startTime": 834.751,
        "endTime": 848.751,
        "transcript": "Tau͡gken merkailkuni ca imna plastic-aaq maavet iterrluku",
        "translation": "However, if one does not have water, he should put somehing, plastic, in here"
    },
    "102": {
        "startTime": 850.058,
        "endTime": 852.933,
        "transcript": "Puqlaminun urugcirluku.",
        "translation": "Thaw it with his body heat."
    },
    "103": {
        "startTime": 852.939,
        "endTime": 856.689,
        "transcript": "Tuaten tua-i alerqulallruit.",
        "translation": "That's how they instructed them."
    },
    "104": {
        "startTime": 858.008,
        "endTime": 862.583,
        "transcript": "Unani-llu cali imarpigmi tuaten ayuqluni.",
        "translation": "It's also like that down in the ocean."
    },
    "105": {
        "startTime": 862.589,
        "endTime": 874.014,
        "transcript": "Arenqiallugeskuni merkailkuni pitami anrutaa, iciw' qilua...",
        "translation": "If he comes to misfortune and is without water, the stomach of his catch, you know, its intestines..."
    },
    "106": {
        "startTime": 874.658,
        "endTime": 876.12,
        "transcript": "Piciatun?",
        "translation": "Anything?"
    },
    "107": {
        "startTime": 876.133,
        "endTime": 876.721,
        "transcript": "Ai?",
        "translation": "What?"
    },
    "108": {
        "startTime": 876.734,
        "endTime": 877.896,
        "transcript": "Piciatun pitani?",
        "translation": "Anything he's caught?"
    },
    "109": {
        "startTime": 877.909,
        "endTime": 883.922,
        "transcript": "Ii-i, piciatun pitani tua-i maklaarem imarpigmiutaam qilua.",
        "translation": "Yes, anything he's caught, the intestines of a bearded seal, a marine animal."
    },
    "110": {
        "startTime": 886.372,
        "endTime": 891.484,
        "transcript": "Kepluku qaillun tua-i pitariluk' piyugtacimitun maqluku.",
        "translation": "Cut it to whatever length he wants and squeeze out the liquid."
    },
    "111": {
        "startTime": 891.497,
        "endTime": 898.897,
        "transcript": "Un'a imarpik umyuangarrluni mernaituq meq egyungvailgan.",
        "translation": "One should not drink down in the ocean at first instinct before the water comes out."
    },
    "112": {
        "startTime": 899.841,
        "endTime": 909.291,
        "transcript": "Arenqiallugeskuni, tamatumek avaqlingqerquni, pitangqerquni",
        "translation": "If ones gets into misfortune, if there's one of those around him"
    },
    "113": {
        "startTime": 909.885,
        "endTime": 922.785,
        "transcript": "Anrutaa wall' qilua imna takqupak qaill' tua-i taktariluku kepluku, maqluku-llu, nutaan-llu qanikcarmek imirluku.",
        "translation": "He should cut its stomach, or its very long intestines to some length, squeeze out the liquid, then fill it with snow."
    },
    "114": {
        "startTime": 926.767,
        "endTime": 928.104,
        "transcript": "Ayagninqigteqaa.",
        "translation": "Please start again."
    },
    "115": {
        "startTime": 928.117,
        "endTime": 931.279,
        "transcript": "Ii-i, au͡gna ava-i pilqa.",
        "translation": "Okay, what I just talked about."
    },
    "116": {
        "startTime": 932.105,
        "endTime": 940.417,
        "transcript": "Imarpigmiutaam qilua maqeqaarluku, tua-i-ll' qanikcarmek imirluku.",
        "translation": "After squeezing out the liquid from the intestines of a marine animal, then fill it with snow."
    },
    "117": {
        "startTime": 941.118,
        "endTime": 945.768,
        "transcript": "Tua-i-llu-gguq maavet iterrluku puqlaminun.",
        "translation": "Then, they said to put it in here to his body heat."
    },
    "118": {
        "startTime": 945.787,
        "endTime": 952.225,
        "transcript": "Tau͡gaam kememinun pivkenaku.",
        "translation": "But, do not put it against his flesh."
    },
    "119": {
        "startTime": 952.225,
        "endTime": 956.763,
        "transcript": "Maavet tau͡gaam tua-i urugarkauluni, waten piluku iquuk qillerrlukek.",
        "translation": "Instead, it should melt here, tying its ends like this."
    },
    "120": {
        "startTime": 956.776,
        "endTime": 964.163,
        "transcript": "Tua-i-gguq tuaten unani merkiutuut arenqiallugeskuneng.",
        "translation": "They said that's how they prepare water down [in the ocean] if they get into misfortune."
    },
    "121": {
        "startTime": 967.076,
        "endTime": 976.576,
        "transcript": "Maani tau͡gken nunam qaingani tua-i arenqiallugeskuni wall'u kiskuni",
        "translation": "However, if one gets into misfortune or sinks into water here on the land"
    },
    "122": {
        "startTime": 981.745,
        "endTime": 993.308,
        "transcript": "Tua-i egmianun nenglliqan aturani nengllingraan piyugngakuniki egmian yuuluki kumelqerpailgaki.",
        "translation": "If it's cold, he should remove his clothes right away even though it's cold if he can before they get cold."
    },
    "123": {
        "startTime": 993.97,
        "endTime": 1001.57,
        "transcript": "Makut tua-i aturani ciulaagluki utumacarluki, all'uki-llu.",
        "translation": "He should quickly wring his clothes to make them better, and put them on."
    },
    "124": {
        "startTime": 1001.577,
        "endTime": 1014.039,
        "transcript": "Nutaan-llu askuniki canegtangqerqan maakun ekiarakun piluki imirluku.",
        "translation": "Then when he puts them on, if there's grass, he should fill them through his lining here."
    },
    "125": {
        "startTime": 1014.99,
        "endTime": 1018.54,
        "transcript": "Makuk-llu waten unkut.",
        "translation": "And [line] these parts down here."
    },
    "126": {
        "startTime": 1019.684,
        "endTime": 1021.959,
        "transcript": "Waten alerquuterluni nengliqan.",
        "translation": "That's his instruction if it's cold."
    },
    "127": {
        "startTime": 1021.965,
        "endTime": 1032.278,
        "transcript": "Ukuk tau͡gaam waten taptaarturlukek pisqellukek, ukut-llu waten, ukuk.",
        "translation": "But, they said that he should keep flexing these here, and these like this."
    },
    "128": {
        "startTime": 1034.54,
        "endTime": 1045.578,
        "transcript": "Tau͡gken-gguq-am waten uitaurquni cikuskani tua-i ukuk pektesciigalkagnek amllirasciigatarkauluni.",
        "translation": "However, they said that if he stays still and they freeze, if these can't move, then he won't be able to walk."
    },
    "129": {
        "startTime": 1045.603,
        "endTime": 1052.616,
        "transcript": "Ukuk-llu cali waten pikagnek tua-i pektesciigatarkauluni.",
        "translation": "And if these [freeze] like this, he won't be able to move."
    }
};